<div tabindex="0" (click)="openRecord()" (keydown.enter)="openRecord()" [title]="value" class="ui-grid-vcenter">
	<a class="pointMe"
	   [ngClass]="{ visited: isVisited }" 
	   (click)="openRecord($event)"> 
		<span [innerHTML]="trustedValue"></span>
	</a>
</div>
